import { render, staticRenderFns } from "./flyOldmanDetail.vue?vue&type=template&id=80b8754e&scoped=true"
import script from "./flyOldmanDetail.vue?vue&type=script&lang=js"
export * from "./flyOldmanDetail.vue?vue&type=script&lang=js"
import style0 from "./flyOldmanDetail.vue?vue&type=style&index=0&id=80b8754e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b8754e",
  null
  
)

export default component.exports